<script>
    export let htmlContent = '';
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
<div class="app-msi_flex-column app-msi_align-items-center">
    <div class="app-msi_content" v-html="config.content">{@html htmlContent}</div>
</div>
